import { render, staticRenderFns } from "./TablePopupItem.vue?vue&type=template&id=4e20e298&scoped=true"
import script from "./TablePopupItem.vue?vue&type=script&lang=js"
export * from "./TablePopupItem.vue?vue&type=script&lang=js"
import style0 from "./TablePopupItem.vue?vue&type=style&index=0&id=4e20e298&scoped=true&lang=css"
import style1 from "./TablePopupItem.vue?vue&type=style&index=1&id=4e20e298&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e20e298",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e20e298')) {
      api.createRecord('4e20e298', component.options)
    } else {
      api.reload('4e20e298', component.options)
    }
    module.hot.accept("./TablePopupItem.vue?vue&type=template&id=4e20e298&scoped=true", function () {
      api.rerender('4e20e298', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/commonPage/components/tableComp/tableItems/TablePopupItem.vue"
export default component.exports